<template>
  <div id="end-of-year-giving">
    <div
      class="page-title-area end-of-year-giving"
      data-aos="fade-up" data-aos-delay="0" data-aos-duration="1000"
    >
      <div class="container">
        <div class="page-title-content">
          <!-- Action Buttons 
          <div class="action-buttons mt-4">
            <router-link to="/get-involved" class="primary-btn">
              Join the Movement
            </router-link>
            <router-link to="/donate" class="secondary-btn">
              Become a Partner in Peace
            </router-link>
          </div>-->
        </div>
      </div>
    </div>

    <div class="loading" style="height: 700px;" v-if="static_pages_data === undefined && !static_pages_error">
      <Loading />
    </div>
    
    
    <!-- Main Content -->
    <div class="main-content">

      <!-- Campaign Overview Section -->
      <section class="campaign-overview py-5">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-12 text-center">
              <p class="mb-0">In honor of our <strong>30th Anniversary in 2026,</strong> we are launching the <strong>Peace Takes All of Us</strong> campaign — an invitation to honor the legacy we’ve built together while ensuring the next 30 years of peace leadership.</p>
            </div>
          </div>
        </div>
      </section>

      <!-- Key Programs Section -->
      <section class="key-programs py-5">
        <div class="row align-items-stretch no-gutters">
          <!-- Box 1: Donate -->
          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column cta-box">
            <h2 class="section-title">Peace Takes All of Us</h2>
            <h3 class="section-subtitle">Be Part of PeaceJam's Next 30 Years</h3>
            <div class="d-flex links-btn mt-auto justify-content-center">
              <a href="#next_30_years" @click.prevent="scrollToNext30Years">
                <span>DONATE</span>
              </a>
            </div>
          </div>
          <!-- Box 2: Reconnect -->
          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column cta-box white-panel">
            <h2 class="section-title">Share your Story</h2>
            <h3 class="section-subtitle">Take the Community Survey</h3>
            <div class="d-flex links-btn mt-auto justify-content-center">
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSf3MILpnX7h9ahLnw-huAPF5PwPSNtZ_WwqylrFvhOTOLrsJQ/viewform?usp=sharing&ouid=100302687729454946371" target="_blank" rel="noopener">
                <span>Reconnect</span>
              </a>
            </div>
          </div>
          <!-- Box 3: Get the Toolkit -->
          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column cta-box">
            <h2 class="section-title">Host Your Own 30th Celebration</h2>
            <h3 class="section-subtitle">Request Your Free Toolkit</h3>
            <div class="d-flex links-btn mt-auto justify-content-center">
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSftcU5aI9G10rvHzoOuj4RoDVLUQRd7hcH9cFols9bCd3OBoQ/viewform?usp=sharing&ouid=100302687729454946371" target="_blank" rel="noopener">
                <span>Get the Toolkit</span>
              </a>
            </div>
          </div>
          <!-- Box 4: Join Us -->
          <div class="col-12 col-md-6 col-lg-3 d-flex flex-column cta-box white-panel">
            <h2 class="section-title">Join our Celebration</h2>
            <h3 class="section-subtitle">Attend an Event</h3>
            <div class="d-flex links-btn mt-auto justify-content-center">
              <a href="#upcoming-events" @click.prevent="scrollToEvents">
                <span>Join Us!</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <div id="funFactsArea">
        <section class="fun-facts-area ptb-30 aos-init aos-animate" data-aos="fade-up" data-aos-delay="0" data-aos-duration="1000">
            <div class="container">
            <div class="section-title">
              <h2>Our 30 Years of Impact</h2>
              <p class="white-space-pre-wrap">From classrooms in Colorado to conferences in South Africa to community service projects worldwide, PeaceJam has nurtured a global movement of youth leaders who are tackling the most urgent challenges of our time. </p>
            </div>
            

            <div id="eoyFactsArea">
              <EoyFactsArea :show="!scrollEoyFacts" />
            </div>

            
            <div class="row justify-content-center mt-5 mb-5">
              <div class="col-lg-8 col-md-8 text-center">
                <img
                  src="../assets/img/eoy-impact-1.jpg"
                  alt="PeaceJam 30 Years Impact"
                  class="img-fluid rounded shadow"
                  style="max-width: 80%; height: auto;"
                />
              </div>
            </div>
          </div>
        </section>
      </div>



      <!-- Your Story Section -->
      <section class="your-story py-5 bg-light" id="30_years_selection">
        <div class="container">
          <div class="row">
            <div class="col-lg-8 mx-auto text-center">
              <h2 class="section-title mb-4">30 Years, Millions of Moments - Add Yours! </h2>
              <p>PeaceJam’s story is not complete without you. Were you impacted by a Laureate’s words, inspired by a conference, or moved by a PeaceJam project?</p>
              <p>We invite alumni, educators, and supporters to share their experiences. Together, these stories will form the foundation of our <strong>30th Anniversary celebration in 2026.</strong></p>

              <div class="campaign-image">
                  <img src="https://flexiblesites.net/uploads/peacejam/originals/517e93d7-6692-4bb4-8bb2-4c69a43103d2.jpg" 
                       alt="PeaceJam young leaders working together" 
                       class="campaign-img" />
              </div>
              
                <div class="mt-5 text-center">
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSf3MILpnX7h9ahLnw-huAPF5PwPSNtZ_WwqylrFvhOTOLrsJQ/viewform?usp=header"
                  target="_blank"
                  rel="noopener"
                  class="btn-share-story"
                  style="display: inline-block; background: #31bfd5; color: white; padding: 15px 40px; border-radius: 5px; font-size: 1.2rem; font-weight: 600; text-decoration: none; border: 2px solid #31bfd5; transition: all 0.3s ease; cursor: pointer; box-shadow: 0 2px 8px rgba(49, 191, 213, 0.2);"
                >
                  Share Your PeaceJam Story
                </a>
                </div>
            </div>
          </div>

          <div class="row highlights-cards">
            <!-- here -->
            <div class="col-lg-3 col-md-6 mb-4">
              <div class="custom-card">
              <div class="custom-card-topbar">Michelle Avaroma</div>
              <div class="custom-card-image">
                <img src="../assets/img/michelle-avaroma.jpg" alt="Michelle Avaroma" />
                <div class="custom-card-video-overlay">
                <a class="play-btn" title="Play Video"  @click="openModal(2)">
                  <svg width="40" height="40" viewBox="0 0 40 40"><circle cx="20" cy="20" r="20" fill="#31bfd5"/><polygon points="16,12 30,20 16,28" fill="#fff"/></svg>
                </a>
                </div>
              </div>
              <div class="custom-card-body">
                <h4 class="title">PeaceJam Alumni</h4>
                <h5 class="joined">Joined PeaceJam 2008</h5>
                <p>Michelle joined PeaceJam as a first-year college student, unsure of what to expect. But what she found quickly changed the course of her... <button class="read-more" data-bs-toggle="modal" data-bs-target="#modalBrian" @click="openModal(2)">Read more</button></p>
              </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-4">
              <div class="custom-card">
              <div class="custom-card-topbar">Wisdom Addo</div>
              <div class="custom-card-image">
                <img src="../assets/img/wisdom-addo.jpg" alt="Wisdom Addo" />
                <div class="custom-card-video-overlay">
                <a class="play-btn" title="Play Video"  @click="openModal(3)">
                  <svg width="40" height="40" viewBox="0 0 40 40"><circle cx="20" cy="20" r="20" fill="#31bfd5"/><polygon points="16,12 30,20 16,28" fill="#fff"/></svg>
                </a>
                </div>
              </div>
              <div class="custom-card-body">
                <h4 class="title">PeaceJam Ghana Affiliate Coordinator</h4>
                <h5 class="joined">Joined PeaceJam 2009</h5>
                <p>Wisdom first encountered PeaceJam and immediately knew: Ghana's young people needed this... <button class="read-more" data-bs-toggle="modal" data-bs-target="#modalBrian" @click="openModal(3)">Read more</button></p>
              </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-4">
              <div class="custom-card">
                <div class="custom-card-topbar">Brian Kelly</div>
                <div class="custom-card-image">
                  <img src="../assets/img/brian-kelly.jpg" alt="Brian Kelly" />
                  <div class="custom-card-video-overlay">
                    <a class="play-btn" title="Play Video" @click="openModal(1)">
                      <svg width="40" height="40" viewBox="0 0 40 40"><circle cx="20" cy="20" r="20" fill="#31bfd5"/><polygon points="16,12 30,20 16,28" fill="#fff"/></svg>
                    </a>
                  </div>
                </div>
                <div class="custom-card-body">
                  <h4 class="title">Global Ambassador</h4>
                  <h5 class="joined">Joined PeaceJam 2016</h5>
                  <p>Every year, people like you make PeaceJam's work possible. Today, we would like to shine a spotlight on Brian Kelly, founder of The Points Guy... <button class="read-more" data-bs-toggle="modal" data-bs-target="#modalBrian" @click="openModal(1)">Read more</button></p>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-4">
              <div class="custom-card">
              <div class="custom-card-topbar">Fay Pretty</div>
              <div class="custom-card-image">
                <img src="../assets/img/fay-pretty.jpg" alt="Fay Pretty" />
                <div class="custom-card-video-overlay">
                <a class="play-btn" title="Play Video"  @click="openModal(4)">
                  <svg width="40" height="40" viewBox="0 0 40 40"><circle cx="20" cy="20" r="20" fill="#31bfd5"/><polygon points="16,12 30,20 16,28" fill="#fff"/></svg>
                </a>
                </div>
              </div>
              <div class="custom-card-body">
                <h4 class="title">PeaceJam UK Coordinator & Youth Team Leader</h4>
                <h5 class="joined">Joined PeaceJam 2017</h5>
                <p>Fay attended her first PeaceJam conference in Winchester at just 17. She remembers walking into a room full... <button class="read-more" data-bs-toggle="modal" data-bs-target="#modalBrian" @click="openModal(4)">Read more</button></p>
              </div>
              </div>
            </div>

            <p class="px-10 text-center">Posting your own PeaceJam story to social media, use our campaign hashtags: <strong>#PeaceJam, #PeaceJam30 #Peace</strong> for a chance to be featured! </p>
          </div>
        </div>
      </section>

      <!-- Upcoming Events Section -->
      <section id="upcoming-events" v-if="events_data === undefined || upcomingEvents.length > 0" class="eoy-events-section py-5">
        <div class="container">
          <div class="text-center mb-5">
            <h2 class="section-title">Upcoming Events</h2>
            <p class="eoy-events-subtitle">Join us at a PeaceJam event near you</p>
          </div>

          <div v-if="events_data === undefined && !events_error" style="height: 300px;">
            <Loading />
          </div>

          <div v-if="upcomingEvents.length > 0">
            <carousel
              :items="3"
              :nav="false"
              :dots="true"
              :autoplay="true"
              :margin="20"
              :responsive="{0: {items: 1}, 768: {items: 2}, 992: {items: 3}}"
            >
              <div
                v-for="event in upcomingEvents"
                :key="event.id"
                class="eoy-event-card"
                @click="goToEvent(event.slug)"
              >

                <div class="eoy-event-img">
                  <DefaultImage :id="event.image" height="180px" width="100%" />
                </div>
                <div class="eoy-event-topbar py-1">
                  <span v-if="event.start_date">{{ formatMonth(event.start_date) }} {{ formatDay(event.start_date) }}</span>
                  <span v-else>Upcoming Event</span>
                </div>
                <div class="eoy-event-body py-2">
                  <h5 class="eoy-event-title">{{ event.title }}</h5>
                </div>
              </div>
            </carousel>
          </div>

          <div class="text-center mt-5">
            <router-link to="/events" class="btn-view-all-events">
              View All Events <i class="flaticon-curve-arrow-1"></i>
            </router-link>
          </div>
        </div>
      </section>

      <!-- The Next 30 Matter Most. For Every Young Leader, Every Community, Every Generation. -->
      <section class="how-to-help py-5" id="next_30_years">
        <div class="container">
          <div class="row">
            <div class="col-12 mb-5">
              <h2 class="text-center">The Next 30 Matter Most. For Every Young Leader, Every Community, Every Generation.</h2>
              <p class="text-center lead">Our model for teaching peace has been proven over the last 30 years, but equipping the next generation to build lasting peace is <strong>more urgent now than ever before.</strong> </p>
              <p class="text-center "><strong>Join us to deepen our impact and share the joy of PeaceJam with the next generation.</strong></p>
            </div>
          </div>
          
            <div class="row mb-5">
            <div class="col-lg-6 mb-4">
              <div class="giving-option">
              <h3>Fuel the Next Generation of Peacebuilders</h3>
              <p>Give today to support Nobel-inspired youth around the world.</p>
              <hr/>

              <!-- $30 donation -->
              <div class="row align-items-center mt-4 mb-4 flex-md-row flex-column">
                <div class="col-md-4 order-md-1 order-1">
                <img
                  src="../assets/img/eoy-giving-donate-1.jpg"
                  alt="PeaceJam donation materials"
                  class="img-fluid rounded shadow mb-3 clickable-donation-img"
                  style="max-width: 100%; height: auto; cursor: pointer;"
                  @click="selectDonationAmount('$30')"
                />
                </div>
                <div class="col-md-8 d-flex align-items-center order-md-2 order-2">
                <div style="font-size:1.2rem; font-weight:500;">
                  <span class="highlighted-text clickable-amount" @click="selectDonationAmount('$30')">$30</span> – Provides materials for one student to participate in PeaceJam.
                </div>
                </div>
              </div>
              <hr/>

              <!-- $300 donation -->
              <div class="row align-items-center mt-4 mb-4 flex-md-row flex-column">
                <div class="col-md-4 order-md-1 order-1">
                <img
                  src="../assets/img/eoy-giving-donate-2.jpg"
                  alt="PHOTO OF CLASSROOM WITH NOBEL LAUREATE"
                  class="img-fluid rounded shadow mb-3 clickable-donation-img"
                  style="max-width: 100%; height: auto; cursor: pointer;"
                  @click="selectDonationAmount('$300')"
                />
                </div>
                <div class="col-md-8 d-flex align-items-center order-md-2 order-2">
                <div style="font-size:1.2rem; font-weight:500;">
                  <span class="highlighted-text clickable-amount" @click="selectDonationAmount('$300')">$300</span> – Supports a classroom learning directly from Nobel Peace Laureates.
                </div>
                </div>
              </div>
              <hr/>

              <!-- $3,000 donation -->
              <div class="row align-items-center mt-4 mb-4 flex-md-row flex-column">
                <div class="col-md-4 order-md-1 order-1">
                <img
                  src="../assets/img/eoy-giving-donate-3.jpg"
                  alt="GROUP PHOTO OF A SCHOOL OR AFFILIATE"
                  class="img-fluid rounded shadow mb-3 clickable-donation-img"
                  style="max-width: 100%; height: auto; cursor: pointer;"
                  @click="selectDonationAmount('$3,000')"
                />
                </div>
                <div class="col-md-8 d-flex align-items-center order-md-2 order-2">
                <div style="font-size:1.2rem; font-weight:500;">
                  <span class="highlighted-text clickable-amount" @click="selectDonationAmount('$3,000')">$3,000</span> – Funds a PeaceJam program at a school for a full year.
                </div>
                </div>
              </div>
              </div>
            </div>
            <div class="col-lg-6 mb-4">
              <div class="giving-option">
              <h3>Become a Monthly PeaceBuilder</h3>
              <p>Your ongoing support sustains year-round education and leadership programs.</p>
              <hr/>

              <!-- $30/month donation -->
              <div class="row align-items-center mt-4 mb-4 flex-md-row flex-column">
                <div class="col-md-4 order-md-1 order-1">
                <img
                  src="../assets/img/eoy-giving-donate-4.jpg"
                  alt="PeaceJam donation materials"
                  class="img-fluid rounded shadow mb-3 clickable-donation-img"
                  style="max-width: 100%; height: auto; cursor: pointer;"
                  @click="selectDonationAmount('$30/month')"
                />
                </div>
                <div class="col-md-8 d-flex align-items-center order-md-2 order-2">
                <div style="font-size:1.2rem; font-weight:500;">
                  <span class="highlighted-text clickable-amount" @click="selectDonationAmount('$30/month')">$30/month</span> – Mentorship for 12 youth leaders each year.
                </div>
                </div>
              </div>
              <hr/>

              <!-- $50/month donation -->
              <div class="row align-items-center mt-4 mb-4 flex-md-row flex-column">
                <div class="col-md-4 order-md-1 order-1">
                <img
                  src="../assets/img/eoy-giving-donate-5.jpg"
                  alt="PHOTO OF CLASSROOM WITH NOBEL LAUREATE"
                  class="img-fluid rounded shadow mb-3 clickable-donation-img"
                  style="max-width: 100%; height: auto; cursor: pointer;"
                  @click="selectDonationAmount('$50/month')"
                />
                </div>
                <div class="col-md-8 d-flex align-items-center order-md-2 order-2">
                <div style="font-size:1.2rem; font-weight:500;">
                  <span class="highlighted-text clickable-amount" @click="selectDonationAmount('$50/month')">$50/month</span> – Continuous programming at a partner school.
                </div>
                </div>
              </div>
              <hr/>

              <!-- $100/month donation -->
              <div class="row align-items-center mt-4 mb-4 flex-md-row flex-column">
                <div class="col-md-4 order-md-1 order-1">
                <img
                  src="../assets/img/eoy-giving-donate-6.jpg"
                  alt="GROUP PHOTO OF A SCHOOL OR AFFILIATE"
                  class="img-fluid rounded shadow mb-3 clickable-donation-img"
                  style="max-width: 100%; height: auto; cursor: pointer;"
                  @click="selectDonationAmount('$100/month')"
                />
                </div>
                <div class="col-md-8 d-flex align-items-center order-md-2 order-2">
                <div style="font-size:1.2rem; font-weight:500;">
                  <span class="highlighted-text clickable-amount" @click="selectDonationAmount('$100/month')">$100/month</span> – Expands PeaceJam curriculum to new communities.
                </div>
                </div>
              </div>
              </div>
            </div>
            </div>

          <!-- Legacy Circle -->
          <div class="major-giving-section mt-5 mb-5">
            <h3>Join the PeaceJam Legacy Circle</h3>
            <p>Celebrate 30 years of impact by joining the <strong>PeaceJam Legacy Circle</strong> - help build the next generation of peace leaders alongside Nobel Laureates.</p>
            <div class="mt-4 text-center">
              <p style="font-size:1.1rem;">
              <strong><span class="highlight">Design Your Legacy. Amplify Peace.</span></strong><br>
              If you're aiming higher with your giving, let's talk. <br/>
              There are some amazing opportunities. Email: <a href="mailto:lauren@peacejam.org" style="color:#31bfd5;">lauren@peacejam.org</a>
              </p>
            </div>
          </div>

          <div class="about-section ptb-50 donate-custom-amount" id="donate-custom-amount">
            <div class="container">
              <div class="row">
                <div class="col-md-12 contact-area">
                  <div class="text-center">
                    <h3 class="mb-1">Make a Customized Donation Here</h3>
                    <p class="mb-5" style="font-size: 17px;">Set your amount and then choose which department shall receive the donation</p>

                    <div class="row">
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

              <!-- Major Giving -->
          <div class="row">
              <div class="col-lg-6 offset-lg-3 mb-4">
              <div class="pay-form contact-wrap">
                <DonateForm ref="donateForm" :form="'eoygiving'" :custom="true"/>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Looking Ahead Section -->
      <section class="looking-ahead py-5">
        <div class="container">
          <div class="row">
            <div class="col-lg-8 mx-auto">
              <div class="mb-4 text-center">
                <img
                  src="../assets/img/eoy-impact-2.jpg"
                  alt="PeaceJam 30 Years Impact 2"
                  class="img-fluid rounded shadow"
                  style="max-width: 80%; height: auto;"
                />
              </div>
              <h2 class="section-title text-center mb-4">PEACE ISN’T A MILESTONE. IT’S A MOVEMENT.</h2>
              <p class="text-center">The first 30 years were only the beginning. The next 30 will determine how far this movement reaches.</p>
              
              <div class="future-vision mt-4">
                <p>By joining the <strong>Peace Takes All of Us</strong> campaign, you are planting seeds of hope, courage, and leadership for the generations to come.</p>
              </div>
              
              <h4 class="mt-5 text-center">Join The Movement</h4>
              <div class="action-buttons-grid mt-4">
                <a
                  href="#30_years_selection"
                  @click.prevent="scrollToStorySection"
                  class="btn btn-primary"
                >
                  Share your Story
                </a>
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSftcU5aI9G10rvHzoOuj4RoDVLUQRd7hcH9cFols9bCd3OBoQ/viewform?usp=sharing&ouid=100302687729454946371"
                  target="_blank"
                  rel="noopener"
                  class="btn btn-primary"
                >
                  Get the Celebration Toolkit
                </a>
                <a
                  href="#next_30_years"
                  @click.prevent="scrollToNext30Years"
                  class="btn btn-primary"
                >
                  Donate for the Next 30 Years
                </a>
                <a
                  href="#upcoming-events"
                  @click.prevent="scrollToEvents"
                  class="btn btn-primary"
                >
                  Attend an Event
                </a>
              </div>
              <p class="text-center mt-3" style="font-size: 0.95rem; font-style: italic; color: #6c757d;">
                All gifts made before December 31 are tax-deductible.
              </p>


              <!-- <div class="footer-additions mt-5">
                <h3 class="mb-3 text-center">PeaceJam by the Numbers</h3>
                <ul class="list-unstyled text-center">
                  <li><strong>1.5 million+</strong> youth have participated in PeaceJam's education and service programs</li>
                  <li><strong>350+</strong> youth conferences hosted across 45 countries</li>
                  <li><strong>30+ Billion Acts Fellows</strong> supported through yearlong mentorship and funding</li>
                  <li><strong>125 million+</strong> Acts of Peace recorded across 171 countries</li>
                </ul>
              </div> -->
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- MODAL 1 -->
    <!-- MODAL 1: Brian Kelly -->
    <div v-if="activeModal === 1" class="modal-overlay" @click.self="closeModal">
      <div class="modal-box">
      <button class="modal-close" @click="closeModal">×</button>
      <h2 class="modal-title">Brian Kelly</h2>
      <div style="position:relative;padding-bottom:56.25%;height:0;overflow:hidden; margin-bottom:30px;">
          <iframe src="https://drive.google.com/file/d/1RPMZoh9qrc_1GBvZffTVUadXlEF1c4_C/preview" frameborder="0" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe>
      </div>
      <p class="modal-text">
        Every year, people like you make PeaceJam’s work possible. Today, we would like to shine a spotlight on Brian Kelly, founder of The Points Guy, who has supported PeaceJam for nearly a decade across Africa and Central America.<br><br>
        When we caught up with him at the 2025 PeaceJam South Africa Conference, he said:<br>
        <em>“PeaceJam gives me hope for the future… the young people are incredible, and they’re going to fix the problems past generations have saddled upon them.”</em><br><br>
        Brian has seen the impact firsthand.<br><br>
        His team members who attended this year’s conference described it as life-changing.<br>
        The chapters he’s supported in Ghana, South Africa, and beyond have grown exponentially.<br><br>
        <em>“Doing good in the world is good for humanity — and it’s also good for business.”</em><br><br>
        Brian gives because he sees a return measured in leadership, courage, and opportunity for young people.
      </p>
      </div>
    </div>

    <!-- MODAL 2: Michelle Avaroma -->
    <div v-if="activeModal === 2" class="modal-overlay" @click.self="closeModal">
      <div class="modal-box">
      <button class="modal-close" @click="closeModal">×</button>
      <h2 class="modal-title">Michelle Avaroma</h2>
      <div style="position:relative;padding-bottom:56.25%;height:0;overflow:hidden; margin-bottom:30px;">
          <iframe src="https://drive.google.com/file/d/1pfiMNqscEhtoDmPWMz-X_C6MoeE6mnvV/preview" frameborder="0" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe>
      </div>
      <p class="modal-text">
        Michelle joined PeaceJam as a first-year college student, unsure of what to expect. But what she found quickly changed the course of her leadership journey.<br><br>
        As a Graduate Assistant, she mentored youth and supported conferences where she watched young people come alive:<br>
        <em>“Some students were so quiet and fearful at first. But over one weekend, something shifted — they started speaking up, taking on leadership, coming back the next year confident and ready.”</em><br><br>
        Her connection with Nobel Peace Laureates was equally transformative — especially Kailash Satyarthi’s powerful presence and Adolfo Pérez Esquivel’s gentle, art-led activism.<br><br>
        <em>“PeaceJam gives young people a space rooted in compassion and community. That’s rare — and it’s powerful.”</em><br><br>
        Michelle now works full-time supporting youth in crisis, living out the same values PeaceJam instilled in her a decade ago.<br><br>
        Her story shows what happens when young leaders are nurtured, believed in, and encouraged to keep going.
      </p>
      </div>
    </div>

    <!-- MODAL 3: Wisdom Addo -->
    <div v-if="activeModal === 3" class="modal-overlay" @click.self="closeModal">
      <div class="modal-box">
      <button class="modal-close" @click="closeModal">×</button>
      <h2 class="modal-title">Wisdom Addo</h2>
      <div style="position:relative;padding-bottom:56.25%;height:0;overflow:hidden; margin-bottom:30px;">
          <iframe src="https://drive.google.com/file/d/1qONJ5GjS-ZLKJ9qle2_MuZ4E3uHq_HBz/preview" frameborder="0" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe>
      </div>
      <p class="modal-text">
        Wisdom first encountered PeaceJam and immediately knew: Ghana’s young people needed this.<br><br>
        So he launched the country’s first PeaceJam chapter with 90 students.<br><br>
        It wasn’t easy. At one point, he nearly stepped away — until his students refused to let him:<br>
        <em>“They came to my office every day for three weeks, saying, ‘We love PeaceJam — you cannot leave us!’ That’s when I realized how deeply it mattered.”</em><br><br>
        Those very students are now mentors, helping lead PeaceJam Ghana as it grows into a vibrant movement that has touched thousands of lives and inspired new PeaceJam chapters across West Africa.<br><br>
        <em>“PeaceJam is a superpower — you feel it in the people whose lives it transforms.”</em><br><br>
        Wisdom’s leadership is paving the way for a true Pan-African PeaceJam network, reaching Ghana, Nigeria, Uganda, Morocco, and beyond.
      </p>
      </div>
    </div>

    <!-- MODAL 4: Fay Pretty -->
    <div v-if="activeModal === 4" class="modal-overlay" @click.self="closeModal">
      <div class="modal-box">
      <button class="modal-close" @click="closeModal">×</button>
      <h2 class="modal-title">Fay Pretty</h2>
      <div style="position:relative;padding-bottom:56.25%;height:0;overflow:hidden; margin-bottom:30px;">
          <iframe src="https://drive.google.com/file/d/1kyBSorEgLIhhXfAkiDN9SNnU3IYPpfav/preview" frameborder="0" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe>
      </div>
      <p class="modal-text">
        Fay attended her first PeaceJam conference in Winchester at just 17. She remembers walking into a room full of young people who cared just as deeply as she did about justice, community, and change.<br><br>
        <em>“You realize you’re not alone. You’re surrounded by people fighting your fight, standing in your corner.”</em><br><br>
        Hearing Nobel Laureate Leymah Gbowee speak about perseverance lit a spark that never faded. Fay soon stepped into leadership roles, supporting youth at conferences, coordinating programs, and helping grow PeaceJam UK.<br><br>
        Today, she is the Chair of the PeaceJam UK Youth Team, guiding new generations of changemakers and ensuring every young person feels the same sense of belonging she experienced years ago.<br><br>
        <em>“PeaceJam gives young people a family — a community that believes in them and gives them the tools to create change.”</em><br><br>
        Fay’s journey is not an exception; it’s the PeaceJam model at work:<br>
        Youth become leaders → leaders become mentors → mentors shape the future of the movement.
      </p>
      </div>
    </div>
  </div>
</template>

<script>
  import api from "../services/api";
  import useSWRV from "swrv";
  import moment from "moment";
  import Loading from "../components/Loading";
  import DefaultImage from "../components/DefaultImage";
  import DonateForm from "../components/DonateForm";
  import carousel from "vue-owl-carousel";
  const EoyFactsArea = () =>  import("../components/EoyFactsArea");


  export default {
    name: "EndOfYearGiving",
    components: {DefaultImage, Loading, DonateForm, EoyFactsArea, carousel},
    created() {
      window.scrollTo(0, 0);
    },
    setup(props, { root }) {
      // Use the same API call as the reconnect page (page_type = 2)
      const {
        data: static_pages_data,
        error: static_pages_error,
        isValidating: static_pages_isValidating
      } = useSWRV(() => `items/static_pages?status=published&filter[page_type]=2`, api.fetcher);

      const {
        data: events_data,
        error: events_error,
      } = useSWRV(() => `items/events?status=published&sort=start_date&limit=6&filter[start_date][gte]=${new Date().toISOString().split('T')[0]}`, api.fetcher);

      return {
        static_pages_data,
        static_pages_error,
        static_pages_isValidating,
        events_data,
        events_error,
      };
    },
    data() {
      return {
        scrollEoyFacts: true,
        activeModal: null
      }
    },
    computed: {
      upcomingEvents() {
        if (!this.events_data || !this.events_data.data) return [];
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return this.events_data.data
          .filter(event => {
            if (!event.start_date) return false;
            return new Date(event.start_date) >= today;
          })
          .sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
      },
    },
    methods: {
      goToEvent(slug) {
        this.$router.push({ name: 'event', params: { url: slug } });
      },
      formatMonth(date) {
        return moment(date).format('MMM');
      },
      formatDay(date) {
        return moment(date).format('D');
      },
      trimString(string, maxLength) {
        if (!string) return '';
        if (string.length <= maxLength) return string;
        return string.substr(0, string.lastIndexOf(' ', maxLength)) + '...';
      },
      scrollToStorySection() {
        const el = document.getElementById('30_years_selection');
        if (el) {
          const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - 100; // Offset to show title above
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      },
      scrollToNext30Years() {
        const el = document.getElementById('next_30_years');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      },
      scrollToEvents() {
        const el = document.getElementById('upcoming-events');
        if (el) {
          const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - 100;
          window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
        } else {
          this.$router.push('/events');
        }
      },
      selectDonationAmount(amountText) {
        // Extract numeric amount from text (e.g., "$30", "$300", "$3,000", "$30/month", "$50/month", "$100/month")
        const amount = amountText.replace(/[^0-9]/g, '');
        if (this.$refs.donateForm && amount) {
          this.$refs.donateForm.contact.amount = parseInt(amount);
        }
        // Scroll to donate form
        const el = document.getElementById('donate-custom-amount');
        if (el) {
          const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - 100;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      },
      openModal(id) {
        this.activeModal = id;
        document.body.style.overflow = "hidden"; // stop background scroll
      },
      closeModal() {
        this.activeModal = null;
        document.body.style.overflow = "auto";
      }
    }
  }
</script>

<style lang="scss">
  #end-of-year-giving {
    .primary-btn {
      border-radius:0px;
      background-color: #31bfd5;
      color: white;
      padding: 12px 24px;
      border: 2px solid #31bfd5;
      &:hover {
        background-color: #28a5b8;
        color: white;
      }
    }

    .secondary-btn {
      border-radius:0px;
      background-color: #786CF0;
      color: #fff;
      padding: 12px 24px;
      border: 2px solid #786CF0;
      &:hover {
        background-color: #6056cd;
        color: white;
      }
    }
    .page-title-area {
      background-position: right center;
      background-size: cover;
      @media (max-width: 768px) {
        min-height: 220px;
      }
    }
    


    .action-buttons {
      display: flex;
      gap: 1rem;
      flex-wrap: wrap;
      justify-content: center;
      
      .btn {
        padding: 12px 24px;
        border-radius: 5px;
        text-decoration: none;
        font-weight: 600;
        transition: all 0.3s ease;
        
        &.btn-primary {
          background-color: #31bfd5;
          color: white;
          border: 2px solid #31bfd5;
          
          &:hover {
            background-color: transparent;
            color: #31bfd5;
          }
        }
        
        &.btn-secondary {
          background-color: transparent;
          color: white;
          border: 2px solid white;
          
          &:hover {
            background-color: white;
            color: #333;
          }
        }
      }
    }
  }

  .end-of-year-giving {
    background-image: url("../assets/img/eoy-giving-banner.jpg");
    background-position: right center;
    min-height: 400px;
    position: relative;

    >div {
      position: relative;
      z-index: 2;
    }

    &:after {
      position: absolute;
      content: "";
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #00000028;
    }
    
    .white-space {
      white-space: pre-wrap;
      line-height: 0;

      ul, li, ol {
        line-height: 1.2;
      }

      a {
        color: #31bfd5;
      }

      h1, h2, h3, h4, h5, h6 {
        margin-bottom: 0;
        line-height: 1.2;
      }
    }
  }
  
  // About section styling to match Alumni page
  #our-vision {
    .about-area-content {
      h3 {
        font-size: 2.5rem;
        font-weight: 600;
        color: #2c3e50;
        margin-bottom: 1.5rem;
        line-height: 1.2;
        
        @media (max-width: 768px) {
          font-size: 2rem;
        }
      }
      
      .lead-text {
        font-size: 1.4rem;
        color: #6c757d;
        font-style: italic;
        margin-bottom: 2rem;
        
        @media (max-width: 768px) {
          font-size: 1.2rem;
        }
      }
    }
  }

  // New section styling
  .main-content {
    
    
    .campaign-overview {
      .section-title {
        color: #2c3e50;
        font-size: 1.5rem;
        font-weight: 700;
        
        @media (max-width: 768px) {
          font-size: 1.8rem;
          text-align: center;
        }
      }
      
      p {
        font-size: 1.1rem;
        line-height: 1.7;
        color: #495057;
        
        strong {
          color: #31bfd5;
          font-weight: 700;
        }
      }
      
      .campaign-image {
        position: relative;
        
        .campaign-img {
          width: 100%;
          height: auto;
          border-radius: 15px;
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
          transition: all 0.3s ease;
          object-fit: cover;
          max-height: 500px;
          
          &:hover {
            box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
            transform: translateY(-3px);
          }
        }
        
        @media (max-width: 991px) {
          margin-top: 3rem;
          
          .campaign-img {
            max-height: 400px;
          }
        }
        
        @media (max-width: 768px) {
          .campaign-img {
            max-height: 320px;
          }
        }
      }
      
      @media (max-width: 768px) {
        .row {
          flex-direction: column-reverse;
        }
        
        .col-lg-8, .col-lg-4 {
          margin-bottom: 2rem;
        }
      }
    }
    
    
    
    .key-programs {
      background: linear-gradient(to right, #28a5b8 0%, #31bfd5 25%, #ffffff 25%, #ffffff 50%, #28a5b8 50%, #31bfd5 75%, #ffffff 75%, #ffffff 100%);
      color: white;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: radial-gradient(circle at 25% 25%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
                         radial-gradient(circle at 75% 75%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);
        pointer-events: none;
      }

      .cta-box {
        padding: 2rem;
        position: relative;
        z-index: 1;
      }

      @media (max-width: 767px) {
        background: #31bfd5;
        padding-bottom: 0 !important;

        .cta-box {
          flex: 0 0 100% !important;
          max-width: 100% !important;
          width: 100% !important;
          background: #31bfd5;
        }

        .white-panel {
          flex: 0 0 100% !important;
          max-width: 100% !important;
          width: 100% !important;
        }
      }

      .white-panel {
        background: white;
        position: relative;
        z-index: 2;

        .section-title {
          color: #31bfd5;
          text-shadow: none;
        }

        .section-subtitle {
          color: #555;
        }

        .links-btn a {
          color: #31bfd5;
          border-color: #31bfd5;

          &:hover {
            background-color: #31bfd5;
            color: white;
            border-color: #31bfd5;
          }
        }
      }

      .section-title {
        color: white;
        font-size: 2rem;
        font-weight: 700;
        margin-bottom: 1rem;
        text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);

        @media (max-width: 768px) {
          font-size: 1.6rem;
        }
      }

      .section-subtitle {
        color: rgba(255, 255, 255, 0.9);
        font-size: 1rem;
        font-weight: 400;
        margin-bottom: 1.5rem;
        line-height: 1.5;
        text-align: center;
      }
      
      .legacy-intro {
        margin-bottom: 3rem;
        
        .lead-intro {
          color: white;
          font-size: 1.6rem;
          font-weight: 600;
          margin-bottom: 1.5rem;
          text-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
          background: rgba(255, 255, 255, 0.1);
          padding: 1.2rem 2rem;
          border-radius: 12px;
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          display: inline-block;
          
          @media (max-width: 768px) {
            font-size: 1.3rem;
            padding: 1rem 1.5rem;
          }
        }
        
        .description {
          color: rgba(255, 255, 255, 0.95);
          font-size: 1.2rem;
          line-height: 1.7;
          margin-bottom: 0;
          max-width: 800px;
          margin-left: auto;
          margin-right: auto;
          
          @media (max-width: 768px) {
            font-size: 1.1rem;
          }
        }
      }
      
      .program-card {
        background: rgba(255, 255, 255, 0.95);
        padding: 2.5rem 2rem;
        border-radius: 20px;
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
        transition: all 0.3s ease;
        height: 100%;
        border: 1px solid rgba(255, 255, 255, 0.3);
        position: relative;
        overflow: hidden;
        color: #333;
        
        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.25);
          background: rgba(255, 255, 255, 1);
        }
        
        // Add subtle gradient overlay on hover
        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #31bfd5, #28a5b8);
          transform: scaleX(0);
          transition: transform 0.3s ease;
        }
        
        &:hover::before {
          transform: scaleX(1);
        }
        
        .program-header {
          margin-bottom: 2rem;
          
          h4 {
            color: #2c3e50;
            font-size: 1.1rem;
            font-weight: 400;
            line-height: 1.4;
            margin-bottom: 0;
            
            strong {
              color: #31bfd5;
              font-weight: 700;
              display: block;
              margin-bottom: 0.5rem;
              font-size: 1.6rem;
            }
            
            @media (max-width: 768px) {
              font-size: 1.2rem;
              
              strong {
                font-size: 1.4rem;
              }
            }
          }
        }
        
        .program-content {
          > p {
            font-size: 1.1rem;
            line-height: 1.6;
            color: #555;
            margin-bottom: 1.5rem;
            font-weight: 400;
          }
          
          ul {
            list-style: none;
            padding: 0;
            margin: 0;
            
            li {
              position: relative;
              padding-left: 1.5rem;
              margin-bottom: 0.8rem;
              font-size: 1rem;
              line-height: 1.6;
              color: #666;
              
              // Custom bullet point
              &::before {
                content: '•';
                position: absolute;
                left: 0;
                top: 0;
                color: #31bfd5;
                font-weight: bold;
                font-size: 1.2rem;
              }
              
              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
        
        @media (max-width: 768px) {
          padding: 2rem 1.5rem;
        }
      }
    }

    #funFactsArea {
      margin-top:100px;
    }

    .links-btn {
      gap: 1.5rem;
      a {
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 10px;
        color: #fff;
        font-size: 1rem;
        font-weight: 600;
        background-color: transparent;
        padding: 12px 28px;
        transition: all 0.3s ease;
        border-radius: 5px;
        border: 2px solid #fff;
        text-decoration: none;
        width: auto;

        &:hover {
          background-color: #fff;
          color: #31bfd5;
          border-color: #fff;
          box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
        }

        img {
          width: 28px;
          height: 28px;
          flex-shrink: 0;
          filter: brightness(0) invert(1);
          transition: filter 0.3s ease;
        }

        &:hover img {
          filter: invert(71%) sepia(50%) saturate(500%) hue-rotate(149deg) brightness(95%) contrast(90%);
        }
      }

      @media (max-width: 768px) {
        a {
          width: 100%;
        }
      }
    }

    .how-to-help {
      .section-title {
        color: #2c3e50;
        font-size: 2.5rem;
        font-weight: 700;
        
        @media (max-width: 768px) {
          font-size: 2rem;
        }
      }
      
      .lead {
        color: #6c757d;
        font-size: 1.2rem;
        padding:15px 0;
        margin-bottom: 0.5rem;
      }
      
      .campaign-image {
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;
        
        .campaign-img {
          width: 100%;
          height: auto;
          border-radius: 15px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
          transition: all 0.3s ease;
          object-fit: cover;
          min-height: 250px;
          max-height: 350px;
          
          &:hover {
            box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
            transform: translateY(-5px) scale(1.02);
          }
        }
        
        // Add subtle overlay for better text contrast if needed
        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(45deg, rgba(49, 191, 213, 0.1) 0%, transparent 50%);
          border-radius: 15px;
          pointer-events: none;
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        
        &:hover::after {
          opacity: 1;
        }
      }
      
      .giving-option {
        background: white;
        padding: 2.5rem 2rem;
        border-radius: 15px;
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
        height: 100%;
        border: 2px solid #f8f9fa;
        transition: all 0.3s ease;
        
        &:hover {
          border-color: #31bfd5;
          box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
          transform: translateY(-3px);
        }
        
        .clickable-donation-img {
          transition: all 0.3s ease;
          
          &:hover {
            transform: scale(1.05);
            box-shadow: 0 8px 20px rgba(49, 191, 213, 0.3);
          }
        }
        
        h3 {
          color: #31bfd5;
          font-size: 1.8rem;
          font-weight: 600;
          margin-bottom: 1.5rem;
        }
        
        p {
          color: #555;
          margin-bottom: 1.5rem;
          line-height: 1.6;
          
          strong {
            color: #31bfd5;
            font-weight: 700;
          }
        }
        
        ul {
          list-style: none;
          padding: 0;
          
          li {
            padding: 0.8rem 0;
            border-bottom: 1px solid #e9ecef;
            font-size: 1rem;
            line-height: 1.6;
            color: #666;
            
            &:last-child {
              border-bottom: none;
            }
            
            strong {
              color: #31bfd5;
              font-weight: 600;
            }
          }
        }
      }
    }

    .eoy-events-section {
      background: #f3f3f3;

      .eoy-events-subtitle {
        font-family: 'Poppins', sans-serif;
        color: #666666;
        font-size: 1rem;
        font-weight: 400;
        margin-top: 8px;
      }

      /* owl dots */
      ::v-deep .owl-dots {
        text-align: center;
        margin-top: 24px;

        .owl-dot {
          span {
            width: 10px;
            height: 10px;
            margin: 5px 7px;
            background: #D6D6D6;
            display: block;
            border-radius: 30px;
            transition: background 200ms ease;
          }

          &.active span {
            background: #786CF0 !important;
          }
        }
      }

      /* make all owl items same height */
      ::v-deep .owl-item {
        display: flex;
      }

      /* ── Card — mirrors .custom-card ── */
      .eoy-event-card {
        cursor: pointer;
        background: #f0f9ff;
        border-radius: 18px;
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.13);
        overflow: hidden;
        transition: box-shadow 0.3s;
        display: flex;
        flex-direction: column;
        margin: 6px 4px 10px;
        width: 100%;

        &:hover {
          box-shadow: 0 15px 40px rgba(49, 191, 213, 0.18);
        }
      }

      /* ── Topbar — mirrors .custom-card-topbar ── */
      .eoy-event-topbar {
        background: #31bfd5;
        color: #fff;
        font-family: 'Montserrat', sans-serif;
        font-weight: 600;
        padding: 10px 15px;
        font-size: 1rem;
        letter-spacing: 0.5px;
        border-bottom: 1px solid #31bfd5;
      }

      /* ── Image — mirrors .custom-card-image ── */
      .eoy-event-img {
        position: relative;
        width: 100%;
        height: 180px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f8f9fa;

        ::v-deep img {
          width: 100%;
          height: 180px;
          object-fit: cover;
          transition: filter 0.3s;
          display: block;
        }

        &:hover ::v-deep img {
          filter: brightness(0.7);
        }

        &:hover .eoy-event-overlay {
          opacity: 1;
        }
      }

      /* ── Hover overlay — mirrors .custom-card-video-overlay ── */
      .eoy-event-overlay {
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.3s;

        span {
          font-family: 'Montserrat', sans-serif;
          color: #fff;
          font-size: 0.78rem;
          font-weight: 700;
          letter-spacing: 2px;
          text-transform: uppercase;
          border: 2px solid rgba(255, 255, 255, 0.9);
          padding: 8px 20px;
          border-radius: 50px;
        }
      }

      /* ── Body — mirrors .custom-card-body ── */
      .eoy-event-body {
        padding: 15px 1.2rem 1.2rem 1.2rem;
        margin-top: 1rem;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        .eoy-event-title {
          font-family: 'Montserrat', sans-serif;
          font-size: 0.94rem;
          font-weight: 700;
          color: #1a1b1e;
          margin-bottom: 8px;
          line-height: 1.45;
          min-height: calc(0.94rem * 1.45 * 2);
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-transform: capitalize;
        }

        .eoy-event-location {
          font-family: 'Poppins', sans-serif;
          font-size: 0.8rem;
          color: #777;
          margin: 0;
          display: flex;
          align-items: center;
          gap: 6px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          i {
            color: #31bfd5;
            flex-shrink: 0;
          }
        }
      }

      /* ── View all button ── */
      .btn-view-all-events {
        display: inline-block;
        font-family: 'Montserrat', sans-serif;
        font-size: 0.9rem;
        font-weight: 700;
        letter-spacing: 0.5px;
        background: #31bfd5;
        color: #fff;
        padding: 12px 34px;
        border-radius: 8px;
        text-decoration: none;
        transition: all 0.3s ease;
        border-bottom: 1px solid #31bfd5;

        i { margin-left: 8px; }

        &:hover {
          background: #4bb2c2;
          color: #fff;
          transform: translateY(-2px);
        }
      }
    }

    .your-story {
      p {
        font-size: 1.1rem;
        line-height: 1.7;
        color: #495057;
        margin-bottom: 1.5rem;
        
        &:last-child {
          font-style: italic;
          color: #6c757d;
        }
      }
      
      .cta-section {
        background: #31bfd5;
        color: white;
        padding: 1.5rem;
        border-radius: 10px;
        
        p {
          margin: 0;
          font-size: 1.2rem;
          font-weight: 600;
          color: white;
        }
      }
    }
    
    // Button styles moved outside .your-story for proper scoping
    .btn-share-story {
      display: inline-block !important;
      background: #31bfd5 !important;
      color: white !important;
      padding: 15px 40px !important;
      border-radius: 5px !important;
      font-size: 1.2rem !important;
      font-weight: 600 !important;
      text-decoration: none !important;
      border: 2px solid #31bfd5 !important;
      transition: all 0.3s ease !important;
      cursor: pointer !important;
      box-shadow: 0 2px 8px rgba(49, 191, 213, 0.2) !important;
      
      &:hover {
        background: #28a5b8 !important;
        border-color: #28a5b8 !important;
        color: white !important;
        text-decoration: none !important;
        transform: translateY(-2px) !important;
        box-shadow: 0 5px 15px rgba(49, 191, 213, 0.3) !important;
      }
      
      &:active {
        transform: translateY(0) !important;
      }
      
      &:visited {
        color: white !important;
      }
      
      &:link {
        color: white !important;
      }
    }

    
    
    .looking-ahead {
      background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
      
      .future-vision {
        background: white;
        padding: 2rem;
        border-radius: 15px;
        box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
        text-align: center;
        
        p {
          font-size: 1.1rem;
          line-height: 1.6;
          color: #495057;
          margin: 0;
        }
      }
      
      .action-buttons-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 1rem;
        max-width: 620px;
        margin: 0 auto;

        .btn {
          display: block;
          width: 100%;
          text-align: center;
          box-sizing: border-box;
          padding: 12px 24px;
          border-radius: 5px;
          text-decoration: none;
          font-weight: 600;
          transition: all 0.3s ease;

          &.btn-primary {
            background-color: #31bfd5;
            color: white;
            border: 2px solid #31bfd5;

            &:hover {
              background-color: transparent;
              color: #31bfd5;
            }
          }
        }

        @media (max-width: 576px) {
          grid-template-columns: 1fr;
        }
      }

      .action-buttons {
        .btn {
          padding: 12px 24px;
          border-radius: 5px;
          text-decoration: none;
          font-weight: 600;
          transition: all 0.3s ease;
          
          &.btn-primary {
            background-color: #31bfd5;
            color: white;
            border: 2px solid #31bfd5;
            
            &:hover {
              background-color: transparent;
              color: #31bfd5;
            }
          }
          
          &.btn-secondary {
            background-color: white;
            color: #31bfd5;
            border: 2px solid #31bfd5;
            
            &:hover {
              background-color: #31bfd5;
              color: white;
            }
          }
        }
      }
    }
    
    .footer-additions {
      h3 {
        color: #31bfd5;
      }
      
      ul li {
        font-size: 1rem;
        line-height: 1.6;
        
        strong {
          color: #31bfd5;
        }
      }
    }
  }

  .highlights-cards {
    margin-top:100px;
    .custom-card {
        background: #fff;
        border-radius: 18px;
        box-shadow: 0 8px 25px rgba(0,0,0,0.13);
        overflow: hidden;
        transition: box-shadow 0.3s;
        display: flex;
        flex-direction: column;
        min-height: 400px;
        position: relative;
      }
      .custom-card:hover {
        box-shadow: 0 15px 40px rgba(49,191,213,0.18);
      }
      .custom-card-topbar {
        background: #786CF0;
        color: #fff;
        font-weight: 600;
        padding: 10px 15px;
        font-size: 1rem;
        letter-spacing: 0.5px;
        border-bottom: 1px solid #5a51b9;
      }
      .custom-card-image {
        position: relative;
        width: 100%;
        height: 180px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f8f9fa;
      }
      .custom-card-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 0;
        transition: filter 0.3s;
        display: block;
      }
      .custom-card-image:hover img {
        filter: brightness(0.7);
      }
      .custom-card-video-overlay {
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.3s;
        pointer-events: none;
      }
      .custom-card-image:hover .custom-card-video-overlay {
        opacity: 1;
        pointer-events: auto;
      }
      .play-btn {
        background: none;
        border: none;
        outline: none;
        cursor: pointer;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.2s;
      }
      .play-btn:hover {
        transform: scale(1.1);
      }
      .custom-card-body {
        padding: 15px 1.2rem 1.2rem 1.2rem;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        .title {
          font-size:0.94em;
          color:red;
        }

        .joined {
          font-size: 0.8rem;
          color: #777;
          margin-bottom: 0.8rem;
        }
      }
      .custom-card-body p {
        font-size: 0.9em;
        color: #444;
        margin-bottom: 0;
      }
      .read-more {
        color: #31bfd5;
        font-weight: 600;
        text-decoration: underline;
        margin-left: 4px;
        font-size: 0.9em;
        cursor: pointer;
        transition: color 0.2s;
        background:none;
        border:0;
      }
      .read-more:hover {
        color: #786CF0;
      }
  }
  
  .major-giving-section {
        margin-top:60px;
        background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
        color: white;
        text-align: center;
        padding: 3rem 3rem;
        border-radius: 15px;

        .highlight {
          color:#31bfd5;
          font-weight: 600;
          font-size:1.3em;
        }
        
        h3 {
          color: #31bfd5;
          font-size: 2rem;
          font-weight: 600;
          text-align: center;
        }
        
        ul {
          list-style: none;
          padding: 0;
          max-width: 600px;
          margin: 0 auto;
          text-align: center;
          
          li {
            padding: 1rem 0;
            border-bottom: 1px solid rgba(255, 255, 255, 0.2);
            font-size: 1.1rem;
            line-height: 1.6;
            
            &:last-child {
              border-bottom: none;
            }
            
            strong {
              color: #31bfd5;
              font-weight: 600;
            }
          }
        }

        p {
          color:#fff;
          font-weight: 300;
        }
      }


  .px-10 {
    padding: 0 10%;
  }

  .highlighted-text {
    color:#28a5b8;
    font-weight:700;

    &.clickable-amount {
      cursor: pointer;
      text-decoration: underline;
      text-underline-offset: 3px;

      &:hover {
        color: #1d8a9e;
      }
    }
  }

  @media (max-width: 768px) {
    #end-of-year-giving .action-buttons {
      flex-direction: column;
      align-items: center;
      
      .btn {
        width: 100%;
        max-width: 300px;
      }
    }
    
    .main-content {
      .how-to-help {
        .giving-option, .major-giving-section {
          margin-bottom: 2rem;
        }
      }
      
      .key-programs .program-card {
        margin-bottom: 2rem;
      }
    }
  }

  
/* ===== Modal ===== */


.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.55);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 40px 20px 20px 20px;
  animation: fadeIn 0.25s ease-out;
  z-index: 9999;
  overflow-y: auto;
}


.modal-box {
  background: #fff;
  padding: 25px;
  border-radius: 14px;
  max-width: 850px;
  width: 100%;
  animation: slideUp 0.25s ease-out;
  position: relative;
  max-height: 85vh;
  overflow-y: auto;
  box-sizing: border-box;
  margin-top: 20px;
  margin-bottom: 20px;
}
  iframe {
    margin-bottom:20px;
  }

.modal-close {
  position: absolute;
  top: 12px;
  right: 14px;
  font-size: 28px;
  background: none;
  border: none;
  cursor: pointer;
}

.modal-title {
  font-size: 24px;
  margin-bottom: 15px;
  font-weight: 600;
}

.modal-text {
  font-size: 16px;
  line-height: 1.6;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (max-width: 480px) {
  .modal-overlay {
    padding-top: 20px;
  }
  .modal-box {
    padding: 12px;
    border-radius: 10px;
    max-width: 98vw;
    max-height: 80vh;
    margin-top: 10px;
    margin-bottom: 10px;
  }
}
  
</style>